import { createIcon } from "@chakra-ui/react";

export const Brandmark = createIcon({
  displayName: "EukaBrandmark",
  viewBox: "0 0 39 55",
  path: [
    <path
      key="1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6667 29.4765C17.7647 24.5726 13.8631 20.6639 8.96734 18.7586C15.9613 16.0366 20.9341 9.22619 20.9341 1.26967V0.000127792H0.94043V17.489V20.0281V34.9779V36.2478C0.94043 46.5876 9.341 55 19.6667 55C29.9928 55 38.393 46.5876 38.393 36.2478V34.9779V17.489H37.1257C29.1829 17.489 22.384 22.4704 19.6667 29.4765ZM35.8583 20.0774V35.0257C29.4864 35.4553 23.9805 39.0887 20.9341 44.3302V36.2478C20.9341 27.7317 27.5206 20.7274 35.8583 20.0774ZM18.3994 36.2478V44.3037C17.594 42.922 16.6087 41.6338 15.4493 40.4723C12.2132 37.2303 7.99987 35.3264 3.47542 35.0251V20.0774C11.8132 20.7274 18.3994 27.7317 18.3994 36.2478ZM3.47542 2.53921H18.3502C17.7339 10.472 11.3945 16.8224 3.47542 17.4398V2.53921ZM3.52905 37.5711C11.4037 38.2104 17.7036 44.5198 18.3455 52.4072C10.4685 51.7672 4.16791 45.4581 3.52905 37.5711ZM20.9874 52.4075C21.2956 48.5763 22.9333 45.0161 25.6766 42.2678C28.4214 39.5183 31.9778 37.8774 35.805 37.5705C35.1659 45.4575 28.8644 51.7675 20.9874 52.4075Z"
      fill="currentColor"
    />,
    <path
      key="2"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.9043 0V2.53938H35.8579V13.512H38.3929V0H24.9043Z"
      fill="currentColor"
    />
  ],
  defaultProps: {
    "aria-label": "Euka Logo",
    color: "text",
    w: "full",
    h: "full"
  }
});
